(() => {
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  const scrollGrid = (button) => {
    const targetId = button.dataset.scrollTarget;
    const target = targetId && document.getElementById(targetId);
    if (!target) return;

    const direction = button.dataset.direction === 'previous' ? -1 : 1;
    const firstCard = target.firstElementChild;
    const styles = window.getComputedStyle(target);
    const gap = parseFloat(styles.columnGap || styles.gap) || 16;
    const distance = firstCard
      ? (firstCard.getBoundingClientRect().width + gap) * direction
      : target.clientWidth * 0.8 * direction;

    target.scrollBy({ left: distance, behavior: 'smooth' });
  };

  const initBadgeLoop = (scope = document) => {
    scope.querySelectorAll('[data-ikon-badge-loop]').forEach((badgeList) => {
      if (badgeList.dataset.loopInitialized === 'true') return;

      badgeList.dataset.loopInitialized = 'true';
      if (badgeList.children.length <= 4 || window.matchMedia(REDUCED_MOTION_QUERY).matches) return;

      const interval = Math.max(Number(badgeList.dataset.loopInterval) || 4000, 1800);
      const originals = [...badgeList.children];
      const track = document.createElement('div');
      track.className = 'ikon-hero__badges-track';

      originals.forEach((badge) => track.append(badge));

      const clones = originals.map((badge) => {
        const clone = badge.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        track.append(clone);
        return clone;
      });

      badgeList.append(track);

      const updateLoopMetrics = () => {
        window.requestAnimationFrame(() => {
          const firstTop = originals[0].offsetTop;
          const loopDistance = clones[0].offsetTop - firstTop;
          const visibleBottom = Math.max(
            ...originals.slice(0, 4).map((badge) => badge.offsetTop + badge.offsetHeight)
          );
          const nextStep = originals.find((badge) => badge.offsetTop > firstTop)?.offsetTop - firstTop;
          const loopSteps = nextStep > 0 ? loopDistance / nextStep : originals.length;

          badgeList.style.setProperty('--ikon-badge-loop-height', `${visibleBottom - firstTop}px`);
          badgeList.style.setProperty('--ikon-badge-loop-distance', `${loopDistance}px`);
          badgeList.style.setProperty('--ikon-badge-loop-duration', `${interval * loopSteps}ms`);
          badgeList.classList.add('is-loop-ready');
        });
      };

      updateLoopMetrics();

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateLoopMetrics).observe(track);
      } else {
        window.addEventListener('resize', updateLoopMetrics, { passive: true });
      }
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-scroll-target]');
    if (button) scrollGrid(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBadgeLoop());
  } else {
    initBadgeLoop();
  }

  document.addEventListener('shopify:section:load', (event) => initBadgeLoop(event.target));
})();
